import { useReportShare } from "lib/analytics/react/hooks";
import { useRouter } from "next/router";

function DiscussShareButton({
  data,
  size = 28,
  from = "agenda",
}: {
  data: any;
  size?: number;
  from?: "agenda" | "floating";
}) {
  const { trackShare } = useReportShare();
  return (
    <div
      className="cursor-pointer"
      onClick={() => {
        trackShare(data?.id);
        function shareMessage() {
          window.Kakao.Share.sendScrap({
            requestUrl:
              `${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/discuss/` + data?.id, // 스크랩 할 URL 입력
          });
        }
        shareMessage();
      }}
      data-gtm-id={`report-${from}-share-button`}
    >
      <ShareIcon size={size} />
    </div>
  );
}
export default DiscussShareButton;
const ShareIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M20.2744 3.03906C22.2921 3.03906 23.9277 4.67467 23.9277 6.69238C23.9277 8.71016 22.2922 10.3457 20.2744 10.3457C19.2963 10.3457 18.4087 9.96091 17.7529 9.33496L11.3008 13.1514C11.3656 13.4237 11.4014 13.7079 11.4014 14C11.4013 14.2114 11.3822 14.4185 11.3477 14.6201L17.7783 18.6396C18.4315 18.0281 19.3091 17.6534 20.2744 17.6533C22.2921 17.6533 23.9276 19.289 23.9277 21.3066C23.9277 23.3244 22.2922 24.96 20.2744 24.96C18.2567 24.9599 16.6211 23.3244 16.6211 21.3066C16.6211 21.0088 16.6574 20.7195 16.7246 20.4424L10.4121 16.4971C9.74553 17.208 8.79851 17.6533 7.74707 17.6533C5.7296 17.6531 4.09392 16.0175 4.09375 14C4.09375 11.9824 5.7295 10.3459 7.74707 10.3457C8.71866 10.3457 9.60139 10.7262 10.2559 11.3447L16.7168 7.52344C16.6547 7.25645 16.6211 6.97827 16.6211 6.69238C16.6212 4.67473 18.2568 3.03916 20.2744 3.03906ZM20.2744 19.7412C19.4098 19.7413 18.7091 20.442 18.709 21.3066C18.709 22.1713 19.4097 22.8729 20.2744 22.873C21.1392 22.873 21.8408 22.1714 21.8408 21.3066C21.8407 20.442 21.1391 19.7412 20.2744 19.7412ZM7.74707 12.4336C6.88251 12.4338 6.18164 13.1354 6.18164 14C6.18181 14.8645 6.88262 15.5652 7.74707 15.5654C8.61173 15.5654 9.31331 14.8646 9.31348 14C9.31348 13.1352 8.61183 12.4336 7.74707 12.4336ZM20.2744 5.12695C19.4098 5.12705 18.7091 5.82775 18.709 6.69238C18.709 7.55708 19.4097 8.25869 20.2744 8.25879C21.1392 8.25879 21.8408 7.55714 21.8408 6.69238C21.8407 5.82769 21.1391 5.12695 20.2744 5.12695Z"
        fill="var(--gray30)"
      />
    </svg>
  );
};
